import { render, staticRenderFns } from "./HxNewsDetails.vue?vue&type=template&id=9ea8b5c4&scoped=true&"
import script from "./HxNewsDetails.vue?vue&type=script&lang=js&"
export * from "./HxNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./HxNewsDetails.vue?vue&type=style&index=0&id=9ea8b5c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea8b5c4",
  null
  
)

component.options.__file = "HxNewsDetails.vue"
export default component.exports